export enum NorificationIcon {
  MESSAGE = 0,
  ALERT = 1,
  SECONDARY = 2
}
